<div class="header-layout">
  <div class="header-text">
    <div class="titleFont">Energy Tracker</div>
    <div [style.color]="primaryColor()" class="signUpText">{{ strapline() }}</div>
  </div>
  @if (headerImage()) {
    <div class="header-logo">
      <img class="brandingImage" [src]="headerImage()" alt="branding image"/>
    </div>
  }
</div>
<diV class="spacer" [style.background]="primaryColor()"></diV>
